"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APAlign = exports.APStack = void 0;
var react_1 = __importDefault(require("react"));
var Common_1 = require("./Common");
function APStack(props) {
    return react_1.default.createElement("div", { style: __assign(__assign({}, props.style), { position: 'relative' }), ref: props.ref }, props.children);
}
exports.APStack = APStack;
function APAlign(props) {
    var align;
    switch (props.align) {
        case 'topLeft':
            align = { top: "0", left: "0" };
            break;
        case 'topCenter':
            align = { top: "0", left: "50%", transform: "translateX(-50%)" };
            break;
        case 'topRight':
            align = { top: "0", right: "0" };
            break;
        case 'centerLeft':
            align = { top: "50%", left: "0", transform: "translateY(-50%)" };
            break;
        case 'center':
            align = { top: "50%", left: "50%", transform: "translate(-50%,-50%)" };
            break;
        case 'centerRight':
            align = { top: "50%", right: "0", transform: "translateY(-50%)" };
            break;
        case 'bottomLeft':
            align = { bottom: "0", left: "0", };
            break;
        case 'bottomCenter':
            align = { bottom: "0", left: "50%", transform: "translateX(-50%)" };
            break;
        case 'bottomRight':
            align = { bottom: "0", right: "0", };
            break;
        case 'fill':
            align = { height: "100%", width: "100%" };
            break;
    }
    return react_1.default.createElement(Common_1.APClone, { style: __assign(__assign(__assign({}, props.style), { position: 'absolute' }), align), noClone: props.noClone }, props.children);
}
exports.APAlign = APAlign;
